<template>
  <b-collapse :key="componentKey" class="panel">
    <!-- <div slot="trigger" class="panel-heading">
      <strong>Contratti assistenza</strong>
    </div>-->
    <div class="panel-block">
      <table class="table is-fullwidth is-narrow">
        <!-- <thead>
          <tr>
            <th>Tipologia</th>
            <th>Prodotto</th>
            <th>Seriale</th>
            <th>Inizio</th>
            <th>Scadenza</th>
            <th>Mesi</th>
            <th>Rinnovo</th>
            <th></th>
            <th></th>
          </tr>
        </thead>-->
        <tbody>
          <tr v-for="(contract, key) in formData" :key="contract.id">
            <td>
              <b-field
                :message="showErrors[key]['type']"
                :type="showErrors[key]['type'] ? 'is-danger' : ''"
              >
                <b-select v-model="contract.type" expanded size="is-small">
                  <option
                    v-for="contractType in contractTypes.results"
                    :key="contractType.id"
                    :value="contractType.id"
                  >
                    {{ contractType.name }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['product_contract']"
                :type="showErrors[key]['product_contract'] ? 'is-danger' : ''"
              >
                <b-select
                  v-model="contract.product_contract"
                  expanded
                  size="is-small"
                >
                  <option
                    v-for="productContract in productContracts"
                    :key="productContract.id"
                    :value="productContract.id"
                  >
                    {{
                      productContract.order ? `${productContract.order} - ` : ""
                    }}
                    {{ findProduct(productContract.product).code }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td>
              <b-field>
                <b-input
                  size="is-small"
                  disabled
                  :value="findProductContract(contract.product_contract).serial"
                ></b-input>
              </b-field>
            </td>
            <td width="80">
              <b-field
                :message="showErrors[key]['amount']"
                :type="showErrors[key]['amount'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contract.amount"
                  type="number"
                  placeholder="qt"
                  size="is-small"
                ></b-input>
              </b-field>
            </td>
            <td width="120px">
              <b-field
                :message="showErrors[key]['start_date']"
                :type="showErrors[key]['start_date'] ? 'is-danger' : ''"
              >
                <datepicker
                  size="is-small"
                  :value="
                    contract.start_date
                      ? new Date(contract.start_date)
                      : new Date()
                  "
                  @input="date => {
                    $set(contract, 'start_date', formatDate(date));
                    updateContractMonths(contract);
                  }"
                ></datepicker>
              </b-field>
            </td>
            <td width="120px">
              <b-field
                :message="showErrors[key]['end_date']"
                :type="showErrors[key]['end_date'] ? 'is-danger' : ''"
              >
                <datepicker
                  size="is-small"
                  :value="
                    contract.end_date ? new Date(contract.end_date) : new Date()
                  "
                  @input="date => {
                    $set(contract, 'end_date', formatDate(date));
                    updateContractMonths(contract);
                  }"
                ></datepicker>
              </b-field>
            </td>
            <td width="50">
              <b-field>
                <b-input
                  size="is-small"
                  :value="
                    calculateMonths(contract.start_date, contract.end_date)
                  "
                  disabled
                ></b-input>
              </b-field>
            </td>
            <td width="50">
              <b-field
                :message="showErrors[key]['is_renewal']"
                :type="showErrors[key]['is_renewal'] ? 'is-danger' : ''"
              >
                <b-checkbox
                  v-model="contract.is_renewal"
                  size="is-medium"
                ></b-checkbox>
              </b-field>
            </td>
            <!-- <td width="150">
              <b-field
                :message="showErrors[key]['notes']"
                :type="showErrors[key]['notes'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contract.notes"
                  size="is-small"
                  readonly
                ></b-input>
              </b-field>
            </td> -->
            <td>
              <button class="button is-small" @click="formData.splice(key, 1)">
                <b-icon icon="minus-circle" type="is-danger" />
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9">
              <div class="buttons">
                <button
                  class="button is-success is-small"
                  @click="addNewContract"
                >
                  <b-icon icon="plus"></b-icon>
                  <span>Aggiungi contratto assistenza</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small"
                  @click="reset"
                >
                  <b-icon icon="undo"></b-icon>
                  <span>Annulla</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small is-primary"
                  type="submit"
                  @click="submit()"
                >
                  <b-icon icon="save"></b-icon>
                  <span>Salva</span>
                </button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </b-collapse>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
import { get, call } from "vuex-pathify"

import dateHelpers from "@/mixins/dateHelpers"

export default {
  mixins: [dateHelpers],
  props: {
    customerId: {
      type: Number,
      required: true
    },
    supportContracts: {
      type: Array,
      required: true
    },
    productContracts: {
      type: Array,
      required: true
    }
  },
  data() {
    // Clone the contracts data and ensure months_of_contact is set for each
    const formData = cloneDeep(this.supportContracts);
    formData.forEach(contract => {
      if (contract.start_date && contract.end_date && !contract.months_of_contact) {
        contract.months_of_contact = parseInt(this.$moment
          .duration(this.$moment(contract.end_date).diff(this.$moment(contract.start_date)))
          .as("months")
          .toPrecision(2));
      }
    });
    
    return {
      componentKey: 0, // used to force rerender
      formData,
      errors: []
    }
  },
  computed: {
    products: get("productTypes/productTypes"),
    contractTypes: get("contractTypes/contractTypes"),
    formHasEdits() {
      // Create sanitized copies of both objects for comparison
      const sanitizedOriginal = this.supportContracts.map(contract => {
        const { months_of_contact, ...rest } = contract;
        return rest;
      });
      
      const sanitizedForm = this.formData.map(contract => {
        const { months_of_contact, ...rest } = contract;
        return rest;
      });
      
      return JSON.stringify(sanitizedOriginal) !== JSON.stringify(sanitizedForm);
    },
    showErrors() {
      if (this.errors.length > 0) {
        return this.errors
      } else {
        let elements = []
        this.formData.forEach(() => {
          elements.push({})
        })
        return elements
      }
    }
  },
  mounted() {
    this.fetchContractTypes()
  },
  methods: {
    fetchContractTypes: call("contractTypes/all"),
    submitAction: call("supportContracts/update"),
    findProduct(id) {
      try {
        return this.products.results.find(product => {
          return product.id === id
        })
      } catch (e) {
        return { name: "" }
      }
    },
    findProductContract(id) {
      try {
        let contract = this.productContracts.find(contract => {
          return contract.id === id
        })
        return contract ? contract : { serial: "" }
      } catch (e) {
        return { serial: "" }
      }
    },
    calculateMonths(startDate, endDate) {
      return this.$moment
        .duration(this.$moment(endDate).diff(this.$moment(startDate)))
        .as("months")
        .toPrecision(2)
    },
    reset() {
      this.errors = []
      this.formData = cloneDeep(this.supportContracts)
      this.componentKey += 1
    },
    async submit() {
      try {
        await this.submitAction({
          customerId: this.customerId,
          data: this.formData
        })
        this.reset()
        this.$toast.open({
          message: "Modificato con successo",
          type: "is-success"
        })
      } catch (response) {
        this.errors = response.data
      }
    },
    updateContractMonths(contract) {
      if (contract.start_date && contract.end_date) {
        contract.months_of_contact = parseInt(this.calculateMonths(
          contract.start_date,
          contract.end_date
        ));
      }
    },
    addNewContract() {
      const newContract = { customer: this.customerId, months_of_contact: 0 };
      this.formData.push(newContract);
    }
  }
}
</script>
